import { render } from "./instructor-setting-withdraw.vue?vue&type=template&id=08607b01"
import script from "./instructor-setting-withdraw.vue?vue&type=script&lang=js"
export * from "./instructor-setting-withdraw.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__